import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_CONTRACTOR';

export async function createContractor(
    userToken: string,
    newContractor: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/contractors/`,
            data: newContractor,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Erreur lors de la création du fournisseur',
            error: error
        });
    }
}
